import React, { useEffect, useState } from "react";
import DefaultButton from "../../buttons/defaultButton";
import DefaultDatePicker from "../../inputs/defaultDatePicker";
import PageTableHeader from "../../pageTableHeader/pageTableHeader";
import DefaultSearchSelectInput from "../../inputs/defaultSearchSelectInput";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DynamicTable from "../../table/dynamicTable";
import Loading from "../../skeleton/loading";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  createPurchaseRequest,
  getStockList,
  updatePurchaseRequest,
} from "../../../../services/workspace/inventory.service";
import moment from "moment";
import { convertToLabelValue, urgencyData } from "../../../../utils/common";
const items = [
  { label: "Purchase Request", path: "/inventory/purchase-request" },
  { label: "Add Request" },
];

const validationSchema = Yup.object().shape({
  expectedDate: Yup.string()
    .trim()
    .required("Expected Date is required")
    .test("isValid", "Invalid date format, expected DD/MM/YYYY", (value) =>
      moment(value, "YYYY-MM-DD", true).isValid()
    ),
  priority: Yup.object()
    .required("Priority is required.")
    .nullable()
    .test("isValid", "Priority is required.", (value) => {
      return value && value.value && value.label;
    }),
});

const AddPurchaseRequest = ({ isModal = false, closeModal = () => null }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState();
  const purchaseRequestColumns = [
    {
      label: "Item",
      key: "item",
      type: "dropdown",
      options: tableData ? tableData : [],
    },
    { label: "Request QTY", key: "quantity", type: "number" },
    { label: "Description", key: "description", type: "text" },
  ];

  const [purchaseItemData, setPurdhaseItemData] = useState([
    { item: "", quantity: 0, description: "" },
  ]);

  const handleInputChange = (rowIndex, field, value) => {
    const updatedRows = [...purchaseItemData];
    updatedRows[rowIndex][field] = value;

    setPurdhaseItemData(updatedRows);
  };
  const fetchData = () => {
    setLoading(true);
    getStockList({})
      .then((response) => {
        setLoading(false);
        setTableData(convertToLabelValue(response.stock.data) || []);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Failed to fetch Purchase Request data!");
        console.error(error);
      });
  };

  
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      expectedDate: data?.expectedDate || "",
      priority: data?.priority || "",
      note: data?.priority || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsSubmitting(true);

      const itemData = [];
      const errorIndex = [];
      purchaseItemData.map((data, index) => {
        if (data.item.id && data.quantity && data.description)
          itemData.push({
            stock_id: data.item.id,
            quantity: parseInt(data.quantity),
            description: data.description,
          });
        else {
          if (!data.item.id) {
            errorIndex.push({ index, key: "item", msg: "Please select Item" });
          }
          if (!data.quantity) {
            errorIndex.push({
              index,
              key: "quantity",
              msg: "Please enter quantity",
            });
          }
          if (!data.description) {
            errorIndex.push({
              index,
              key: "description",
              msg: "Please enter description",
            });
          }
        }
      });

      setError(errorIndex);
      if (errorIndex && !!errorIndex.length) {
        setIsSubmitting(false);
        return;
      }

      const payload = {
        expected_date: values.expectedDate,
        priority: parseInt(values.priority.value), // 0->low, 1->medium, 2->high
        items: itemData,
        notes: values.note,
      };
      if (id) {
        updatePurchaseRequest(payload, id)
          .then((response) => {
            toast.success("Purchase Request updated successfully!");
            navigate("/inventory/purchase-request");
          })

          .catch((error) => {
            setIsSubmitting(false);
            toast.error(
              "Failed to Purchase Request!" + error.response.data?.message
            );

          });
      } else {
        createPurchaseRequest(payload)
          .then((response) => {
            toast.success("Purchase Request created successfully!");
            navigate("/inventory/purchase-request");
          })
          .catch((error) => {
            setIsSubmitting(false);
            toast.error(
              "Failed to create Purchase Request!" +
                error.response.data?.message
            );
          });
      }
    },
  });

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />

      {loading ? (
        <Loading />
      ) : (
        <div className={"bg-white flex flex-col gap-2"}>
          <form onSubmit={handleSubmit} className="flex flex-col">
            <div className={"flex flex-col"}>
              <div
                className={"grid grid-cols-1 md:grid-cols-2 gap-4 gap-y-2 p-4"}
              >
                <DefaultDatePicker
                  label={"Expected Date"}
                  name={"expectedDate"}
                  placeholder={"Select"}
                  value={values.expectedDate}
                  onChange={(data) => setFieldValue("expectedDate", data)}
                  onBlur={handleBlur}
                  error={
                    touched.expectedDate && errors.expectedDate
                      ? errors.expectedDate
                      : ""
                  }
                  required
                  type="date"
                />
                <DefaultSearchSelectInput
                  label={"Priority"}
                  classnames="border-white hover:border-borderColor"
                  name="priority"
                  value={values.priority}
                  options={urgencyData}
                  onChange={(value) => {
                    setFieldValue("priority", value);
                  }}
                  onBlur={handleBlur}
                  error={
                    touched.priority && errors.priority ? errors.priority : ""
                  }
                  required
                />
              </div>

              {/* Dynamic Table */}
              <div className="p-4 ">
                <DynamicTable
                columns={purchaseRequestColumns}
                // categories={categories}
                rows={purchaseItemData}
                setRows={setPurdhaseItemData}
                error={error}
                handleInputChange={handleInputChange}
              />
              </div>

              {/* textarea */}
              <div className="p-4">
                <DefaultTextarea
                  classnames="rounded-md border-0 bg-light"
                  name={"note"}
                  label={"Description (Optional)"}
                  placeholder={"Write  here..."}
                  boxheight={15}
                  value={values.note}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.note && errors.note ? errors.note : ""}
                />
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex flex-row gap-2 p-4">
              <DefaultButton
                variant="default"
                name={"Add"}
                type="submit"
                loading={isSubmitting}
              />
              <DefaultButton variant="secondary" name={"Cancel"} type="submit" />
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default AddPurchaseRequest;
